import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  References31yy1vpluik8j as References,
  AdminTitleFields1r7jr8w0z0gjc as AdminTitleFields,
  AdminTableColumns127mx0x3shj3w as AdminTableColumns,
  NaturalSort21fbc8xpuy7g0 as NaturalSort,
  IndexUniqueness_Unique_getInstance3k1wv494ui8l1 as IndexUniqueness_Unique_getInstance,
  Index2tzg8vllut89f as Index,
  Group209swmzf2sz2h as Group,
  Description1f0zycfwk0zld as Description,
  MaxLength2eo8ysfurfau1 as MaxLength,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import {
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance386m8xfiehsti as Companion_getInstance } from './types.mjs';
import {
  compareTo1g8l26b65emtd as compareTo,
  TypedIdexo9ecsepo30 as TypedId,
  HasId24qpfucecockd as HasId,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { Companion_getInstance13ujfby7pfhe7 as Companion_getInstance_1 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { todayIn1xeyw1nmvf0b4 as todayIn } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import {
  $serializer_getInstance2m8ynx42p4oox as $serializer_getInstance,
  $serializer_getInstance21thv1dv9fwx4 as $serializer_getInstance_0,
  $serializer_getInstance1dhvc4iof5db1 as $serializer_getInstance_1,
  $serializer_getInstance1a39stva24llm as $serializer_getInstance_2,
} from './domain.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import {
  EmailAddressSerializer_getInstancezn5b5405tqyz as EmailAddressSerializer_getInstance,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
  PhoneNumberSerializer_getInstanceq35z0l42la4e as PhoneNumberSerializer_getInstance,
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  EmailAddress__hashCode_impl_wizg9y14xq3olyjcev0 as EmailAddress__hashCode_impl_wizg9y,
  PhoneNumber__hashCode_impl_t98twlqkqzqu7p5mbp as PhoneNumber__hashCode_impl_t98twl,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { now2qufyxzn5e863 as now } from './clock.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _ID___init__impl__k1lb7e(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5($this) {
  return $this;
}
function ID__toString_impl_y5caka($this) {
  return _ID___get_raw__impl__92g6u5($this).toString();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.AppRelease.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(AppRelease())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_sos296_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_sos296_k$(encoder, value instanceof ID() ? value.raw_1 : THROW_CCE());
      }
      deserialize_m8wbqx_k$(decoder) {
        return _ID___init__impl__k1lb7e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID())(this.deserialize_m8wbqx_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_3() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function ID__hashCode_impl_f4lulz($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p($this, other) {
  if (!(other instanceof ID()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID())(other instanceof ID() ? other.raw_1 : THROW_CCE()));
}
function AppRelease$Companion$$childSerializers$_anonymous__kmoio4() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var IDClass;
function ID() {
  if (IDClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_3});
    IDClass = $;
  }
  return IDClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, lazy(tmp_0, AppRelease$Companion$$childSerializers$_anonymous__kmoio4), null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.AppRelease', this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('version', false);
        tmp0_serialDesc.addElement_5pzumi_k$('platform', false);
        tmp0_serialDesc.addElement_5pzumi_k$('releaseDate', true);
        tmp0_serialDesc.addElement_5pzumi_k$('requiredUpdate', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['platform', 'version']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['platform', 'version', 'releaseDate', 'requiredUpdate']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-releaseDate']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_pmkirz_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_3(), new (ID())(value._id_1));
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.version_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.platform_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !value.releaseDate_1.equals(todayIn(System_instance, Companion_getInstance_1().currentSystemDefault_9rduv_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), value.releaseDate_1);
        }
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 4, value.requiredUpdate_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_pmkirz_k$(encoder, value instanceof AppRelease() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance_3().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_3();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_3();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AppRelease().new_org_thecommunitygroupinc_cares_AppRelease_toeu6f_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_3().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_3(), StringSerializer_getInstance(), tmp0_cached[2].get_value_j01efc_k$(), LocalDateSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_4() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var AppReleaseClass;
function AppRelease() {
  if (AppReleaseClass === VOID) {
    class $ {
      constructor(_id, version, platform, releaseDate, requiredUpdate) {
        Companion_getInstance_3();
        _id = _id === VOID ? _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        releaseDate = releaseDate === VOID ? todayIn(System_instance, Companion_getInstance_1().currentSystemDefault_9rduv_k$()) : releaseDate;
        this._id_1 = _id;
        this.version_1 = version;
        this.platform_1 = platform;
        this.releaseDate_1 = releaseDate;
        this.requiredUpdate_1 = requiredUpdate;
      }
      get__id_z3y9zu_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID())(this.get__id_z3y9zu_k$());
      }
      toString() {
        return 'AppRelease(_id=' + ID__toString_impl_y5caka(this._id_1) + ', version=' + this.version_1 + ', platform=' + toString(this.platform_1) + ', releaseDate=' + this.releaseDate_1.toString() + ', requiredUpdate=' + this.requiredUpdate_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz(this._id_1);
        result = imul(result, 31) + getStringHashCode(this.version_1) | 0;
        result = imul(result, 31) + this.platform_1.hashCode() | 0;
        result = imul(result, 31) + this.releaseDate_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.requiredUpdate_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AppRelease()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.version_1 === other.version_1))
          return false;
        if (!this.platform_1.equals(other.platform_1))
          return false;
        if (!this.releaseDate_1.equals(other.releaseDate_1))
          return false;
        if (!(this.requiredUpdate_1 === other.requiredUpdate_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_AppRelease_toeu6f_k$(seen0, _id, version, platform, releaseDate, requiredUpdate, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(22 === (22 & seen0))) {
          throwMissingFieldException(seen0, 22, $serializer_getInstance_4().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.version_1 = version;
        $this.platform_1 = platform;
        if (0 === (seen0 & 8))
          $this.releaseDate_1 = todayIn(System_instance, Companion_getInstance_1().currentSystemDefault_9rduv_k$());
        else
          $this.releaseDate_1 = releaseDate;
        $this.requiredUpdate_1 = requiredUpdate;
        return $this;
      }
    }
    initMetadataForClass($, 'AppRelease', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_4});
    AppReleaseClass = $;
  }
  return AppReleaseClass;
}
function _ID___init__impl__k1lb7e_0(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_0($this) {
  return $this;
}
function ID__toString_impl_y5caka_0($this) {
  return _ID___get_raw__impl__92g6u5_0($this).toString();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.User.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(User())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_edh01d_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_0(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_edh01d_k$(encoder, value instanceof ID_0() ? value.raw_1 : THROW_CCE());
      }
      deserialize_5szxdq_k$(decoder) {
        return _ID___init__impl__k1lb7e_0(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_0())(this.deserialize_5szxdq_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_5() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function ID__hashCode_impl_f4lulz_0($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_0($this, other) {
  if (!(other instanceof ID_0()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_0($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_0())(other instanceof ID_0() ? other.raw_1 : THROW_CCE()));
}
function User$Companion$$childSerializers$_anonymous__6nf9sv() {
  return Companion_getInstance_6().serializer_9w0wvi_k$();
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance());
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_1() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_0());
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_2() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_1());
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_3() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_2());
}
var IDClass_0;
function ID_0() {
  if (IDClass_0 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_0(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_0(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_0(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_0(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_0(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_5});
    IDClass_0 = $;
  }
  return IDClass_0;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, User$Companion$$childSerializers$_anonymous__6nf9sv);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, User$Companion$$childSerializers$_anonymous__6nf9sv_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, User$Companion$$childSerializers$_anonymous__6nf9sv_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, User$Companion$$childSerializers$_anonymous__6nf9sv_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, tmp_1, tmp_3, tmp_5, tmp_7, lazy(tmp_8, User$Companion$$childSerializers$_anonymous__6nf9sv_3), null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_5() {
  if (Companion_instance_3 === VOID)
    new (Companion_2())();
  return Companion_instance_3;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.User', this, 13);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('email', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())(IndexUniqueness_Unique_getInstance()));
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('phone', true);
        tmp0_serialDesc.addElement_5pzumi_k$('preferredLanguage', true);
        tmp0_serialDesc.addElement_5pzumi_k$('role', true);
        tmp0_serialDesc.addElement_5pzumi_k$('managesEmployers', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('access'));
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())("Grants access to these employers' children and funding."));
        tmp0_serialDesc.addElement_5pzumi_k$('managesProviders', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('access'));
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Grants access to every location under these providers.'));
        tmp0_serialDesc.addElement_5pzumi_k$('managesLocations', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('access'));
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Grants access to just these locations, for staff who work at one site rather than for the whole provider.'));
        tmp0_serialDesc.addElement_5pzumi_k$('managesFamilies', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('access'));
        tmp0_serialDesc.addElement_5pzumi_k$('createdAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('updatedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['name', 'email']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['name', 'email', 'role', 'phone']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['~name']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_vl0v3o_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_5().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_5(), new (ID_0())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.email_1));
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.name_1);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3)) {
          tmp = true;
        } else {
          var tmp_0 = value.phone_1;
          tmp = !((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = PhoneNumberSerializer_getInstance();
          var tmp_2 = value.phone_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, tmp_1, tmp_2 == null ? null : new (PhoneNumber())(tmp_2));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.preferredLanguage_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.preferredLanguage_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !value.role_1.equals(UserRole_User_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, tmp2_cached[5].get_value_j01efc_k$(), value.role_1);
        }
        var tmp_3;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6)) {
          tmp_3 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp_3 = !equals(value.managesEmployers_1, tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, tmp2_cached[6].get_value_j01efc_k$(), value.managesEmployers_1);
        }
        var tmp_4;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7)) {
          tmp_4 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_4 = !equals(value.managesProviders_1, tmp$ret$1);
        }
        if (tmp_4) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, tmp2_cached[7].get_value_j01efc_k$(), value.managesProviders_1);
        }
        var tmp_5;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8)) {
          tmp_5 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$2 = emptySet();
          tmp_5 = !equals(value.managesLocations_1, tmp$ret$2);
        }
        if (tmp_5) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 8, tmp2_cached[8].get_value_j01efc_k$(), value.managesLocations_1);
        }
        var tmp_6;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9)) {
          tmp_6 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$3 = emptySet();
          tmp_6 = !equals(value.managesFamilies_1, tmp$ret$3);
        }
        if (tmp_6) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 9, tmp2_cached[9].get_value_j01efc_k$(), value.managesFamilies_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 10) ? true : !value.createdAt_1.equals(now())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 10, InstantSerializer_getInstance(), value.createdAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 11) ? true : !value.updatedAt_1.equals(now())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 11, InstantSerializer_getInstance(), value.updatedAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 12) ? true : !(value.active_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 12, value.active_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_vl0v3o_k$(encoder, value instanceof User() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = false;
        var tmp17_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp18_cached = Companion_getInstance_5().$childSerializers_1;
        if (tmp17_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_5();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_0())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = EmailAddressSerializer_getInstance();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (EmailAddress())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_5 = PhoneNumberSerializer_getInstance();
          var tmp_6 = tmp7_local3;
          var tmp_7 = tmp17_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp_5, tmp_6 == null ? null : new (PhoneNumber())(tmp_6));
          tmp7_local3 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp18_cached[5].get_value_j01efc_k$(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp18_cached[6].get_value_j01efc_k$(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, tmp18_cached[7].get_value_j01efc_k$(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp18_cached[8].get_value_j01efc_k$(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, tmp18_cached[9].get_value_j01efc_k$(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 10, InstantSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 11, InstantSerializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp17_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_5();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_0())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = EmailAddressSerializer_getInstance();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (EmailAddress())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_14 = PhoneNumberSerializer_getInstance();
                var tmp_15 = tmp7_local3;
                var tmp_16 = tmp17_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp_14, tmp_15 == null ? null : new (PhoneNumber())(tmp_15));
                tmp7_local3 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp18_cached[5].get_value_j01efc_k$(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp18_cached[6].get_value_j01efc_k$(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, tmp18_cached[7].get_value_j01efc_k$(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp18_cached[8].get_value_j01efc_k$(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, tmp18_cached[9].get_value_j01efc_k$(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 10, InstantSerializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 11, InstantSerializer_getInstance(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp17_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp17_input.endStructure_1xqz0n_k$(tmp0_desc);
        return User().new_org_thecommunitygroupinc_cares_User_ht1r52_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_5().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_5(), EmailAddressSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(PhoneNumberSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[5].get_value_j01efc_k$(), tmp0_cached[6].get_value_j01efc_k$(), tmp0_cached[7].get_value_j01efc_k$(), tmp0_cached[8].get_value_j01efc_k$(), tmp0_cached[9].get_value_j01efc_k$(), InstantSerializer_getInstance(), InstantSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_6() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var UserClass;
function User() {
  if (UserClass === VOID) {
    class $ {
      constructor(_id, email, name, phone, preferredLanguage, role, managesEmployers, managesProviders, managesLocations, managesFamilies, createdAt, updatedAt, active) {
        Companion_getInstance_5();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        phone = phone === VOID ? null : phone;
        preferredLanguage = preferredLanguage === VOID ? '' : preferredLanguage;
        role = role === VOID ? UserRole_User_getInstance() : role;
        var tmp;
        if (managesEmployers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = managesEmployers;
        }
        managesEmployers = tmp;
        var tmp_0;
        if (managesProviders === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = managesProviders;
        }
        managesProviders = tmp_0;
        var tmp_1;
        if (managesLocations === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = managesLocations;
        }
        managesLocations = tmp_1;
        var tmp_2;
        if (managesFamilies === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_2 = emptySet();
        } else {
          tmp_2 = managesFamilies;
        }
        managesFamilies = tmp_2;
        createdAt = createdAt === VOID ? now() : createdAt;
        updatedAt = updatedAt === VOID ? now() : updatedAt;
        active = active === VOID ? true : active;
        this._id_1 = _id;
        this.email_1 = email;
        this.name_1 = name;
        this.phone_1 = phone;
        this.preferredLanguage_1 = preferredLanguage;
        this.role_1 = role;
        this.managesEmployers_1 = managesEmployers;
        this.managesProviders_1 = managesProviders;
        this.managesLocations_1 = managesLocations;
        this.managesFamilies_1 = managesFamilies;
        this.createdAt_1 = createdAt;
        this.updatedAt_1 = updatedAt;
        this.active_1 = active;
      }
      get__id_dj7v2t_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_0())(this.get__id_dj7v2t_k$());
      }
      copy_dg961j_k$(_id, email, name, phone, preferredLanguage, role, managesEmployers, managesProviders, managesLocations, managesFamilies, createdAt, updatedAt, active) {
        return new (User())(_id, email, name, phone, preferredLanguage, role, managesEmployers, managesProviders, managesLocations, managesFamilies, createdAt, updatedAt, active);
      }
      copy$default_jtwamt_k$(_id, email, name, phone, preferredLanguage, role, managesEmployers, managesProviders, managesLocations, managesFamilies, createdAt, updatedAt, active, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        email = email === VOID ? this.email_1 : email;
        name = name === VOID ? this.name_1 : name;
        phone = phone === VOID ? this.phone_1 : phone;
        preferredLanguage = preferredLanguage === VOID ? this.preferredLanguage_1 : preferredLanguage;
        role = role === VOID ? this.role_1 : role;
        managesEmployers = managesEmployers === VOID ? this.managesEmployers_1 : managesEmployers;
        managesProviders = managesProviders === VOID ? this.managesProviders_1 : managesProviders;
        managesLocations = managesLocations === VOID ? this.managesLocations_1 : managesLocations;
        managesFamilies = managesFamilies === VOID ? this.managesFamilies_1 : managesFamilies;
        createdAt = createdAt === VOID ? this.createdAt_1 : createdAt;
        updatedAt = updatedAt === VOID ? this.updatedAt_1 : updatedAt;
        active = active === VOID ? this.active_1 : active;
        var tmp;
        if ($super === VOID) {
          tmp = this.copy_dg961j_k$(_id, email, name, phone, preferredLanguage, role, managesEmployers, managesProviders, managesLocations, managesFamilies, createdAt, updatedAt, active);
        } else {
          var tmp_0 = $super.copy_dg961j_k$;
          var tmp_1 = phone;
          tmp = tmp_0.call(this, new (ID_0())(_id), new (EmailAddress())(email), name, tmp_1 == null ? null : new (PhoneNumber())(tmp_1), preferredLanguage, role, managesEmployers, managesProviders, managesLocations, managesFamilies, createdAt, updatedAt, active);
        }
        return tmp;
      }
      toString() {
        var tmp = ID__toString_impl_y5caka_0(this._id_1);
        var tmp_0 = EmailAddress__toString_impl_artjh3(this.email_1);
        var tmp_1 = this.phone_1;
        return 'User(_id=' + tmp + ', email=' + tmp_0 + ', name=' + this.name_1 + ', phone=' + toString_0(tmp_1 == null ? null : new (PhoneNumber())(tmp_1)) + ', preferredLanguage=' + this.preferredLanguage_1 + ', role=' + toString(this.role_1) + ', managesEmployers=' + toString(this.managesEmployers_1) + ', managesProviders=' + toString(this.managesProviders_1) + ', managesLocations=' + toString(this.managesLocations_1) + ', managesFamilies=' + toString(this.managesFamilies_1) + ', createdAt=' + this.createdAt_1.toString() + ', updatedAt=' + this.updatedAt_1.toString() + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_0(this._id_1);
        result = imul(result, 31) + EmailAddress__hashCode_impl_wizg9y(this.email_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.phone_1;
        if ((tmp_1 == null ? null : new (PhoneNumber())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = PhoneNumber__hashCode_impl_t98twl(this.phone_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + getStringHashCode(this.preferredLanguage_1) | 0;
        result = imul(result, 31) + this.role_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.managesEmployers_1) | 0;
        result = imul(result, 31) + hashCode(this.managesProviders_1) | 0;
        result = imul(result, 31) + hashCode(this.managesLocations_1) | 0;
        result = imul(result, 31) + hashCode(this.managesFamilies_1) | 0;
        result = imul(result, 31) + this.createdAt_1.hashCode() | 0;
        result = imul(result, 31) + this.updatedAt_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof User()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.email_1 === other.email_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        var tmp = this.phone_1;
        var tmp_0 = tmp == null ? null : new (PhoneNumber())(tmp);
        var tmp_1 = other.phone_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (PhoneNumber())(tmp_1)))
          return false;
        if (!(this.preferredLanguage_1 === other.preferredLanguage_1))
          return false;
        if (!this.role_1.equals(other.role_1))
          return false;
        if (!equals(this.managesEmployers_1, other.managesEmployers_1))
          return false;
        if (!equals(this.managesProviders_1, other.managesProviders_1))
          return false;
        if (!equals(this.managesLocations_1, other.managesLocations_1))
          return false;
        if (!equals(this.managesFamilies_1, other.managesFamilies_1))
          return false;
        if (!this.createdAt_1.equals(other.createdAt_1))
          return false;
        if (!this.updatedAt_1.equals(other.updatedAt_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_User_ht1r52_k$(seen0, _id, email, name, phone, preferredLanguage, role, managesEmployers, managesProviders, managesLocations, managesFamilies, createdAt, updatedAt, active, serializationConstructorMarker) {
        Companion_getInstance_5();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_6().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.email_1 = email;
        $this.name_1 = name;
        if (0 === (seen0 & 8))
          $this.phone_1 = null;
        else
          $this.phone_1 = phone;
        if (0 === (seen0 & 16))
          $this.preferredLanguage_1 = '';
        else
          $this.preferredLanguage_1 = preferredLanguage;
        if (0 === (seen0 & 32))
          $this.role_1 = UserRole_User_getInstance();
        else
          $this.role_1 = role;
        if (0 === (seen0 & 64)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.managesEmployers_1 = emptySet();
        } else
          $this.managesEmployers_1 = managesEmployers;
        if (0 === (seen0 & 128)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.managesProviders_1 = emptySet();
        } else
          $this.managesProviders_1 = managesProviders;
        if (0 === (seen0 & 256)) {
          var tmp_1 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_1.managesLocations_1 = emptySet();
        } else
          $this.managesLocations_1 = managesLocations;
        if (0 === (seen0 & 512)) {
          var tmp_2 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_2.managesFamilies_1 = emptySet();
        } else
          $this.managesFamilies_1 = managesFamilies;
        if (0 === (seen0 & 1024))
          $this.createdAt_1 = now();
        else
          $this.createdAt_1 = createdAt;
        if (0 === (seen0 & 2048))
          $this.updatedAt_1 = now();
        else
          $this.updatedAt_1 = updatedAt;
        if (0 === (seen0 & 4096))
          $this.active_1 = true;
        else
          $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'User', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_6});
    UserClass = $;
  }
  return UserClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function UserRole$Companion$_anonymous__pdvotq() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.UserRole', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  UserRole_Anonymous_instance = new (UserRole())('Anonymous', 0, 'Anonymous');
  UserRole_User_instance = new (UserRole())('User', 1, 'User');
  UserRole_Admin_instance = new (UserRole())('Admin', 2, 'Admin');
  UserRole_Developer_instance = new (UserRole())('Developer', 3, 'Developer');
  UserRole_Root_instance = new (UserRole())('Root', 4, 'Root');
  if (Companion_instance_4 === VOID) {
    Companion_instance;
    new (Companion_3())();
  }
}
var UserRole_Anonymous_instance;
var UserRole_User_instance;
var UserRole_Admin_instance;
var UserRole_Developer_instance;
var UserRole_Root_instance;
function values() {
  static_init();
  return [UserRole_Anonymous_getInstance(), UserRole_User_getInstance(), UserRole_Admin_getInstance(), UserRole_Developer_getInstance(), UserRole_Root_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, UserRole$Companion$_anonymous__pdvotq);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_6() {
  static_init();
  return Companion_instance_4;
}
var $ENTRIES;
var UserRoleClass;
function UserRole() {
  if (UserRoleClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'UserRole', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_6});
    UserRoleClass = $;
  }
  return UserRoleClass;
}
function _ID___init__impl__k1lb7e_1(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_1($this) {
  return $this;
}
function ID__toString_impl_y5caka_1($this) {
  return _ID___get_raw__impl__92g6u5_1($this);
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_7() {
  return Companion_instance_5;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.FcmToken.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(FcmToken())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_3hncmr_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeString_424b5v_k$(_ID___get_raw__impl__92g6u5_1(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_3hncmr_k$(encoder, value instanceof ID_1() ? value.raw_1 : THROW_CCE());
      }
      deserialize_79w94s_k$(decoder) {
        return _ID___init__impl__k1lb7e_1(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeString_x3hxsx_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_1())(this.deserialize_79w94s_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_7() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
function ID__hashCode_impl_f4lulz_1($this) {
  return getStringHashCode($this);
}
function ID__equals_impl_g09z1p_1($this, other) {
  if (!(other instanceof ID_1()))
    return false;
  if (!($this === other.raw_1))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_1($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_1())(other instanceof ID_1() ? other.raw_1 : THROW_CCE()));
}
var IDClass_1;
function ID_1() {
  if (IDClass_1 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_1(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_1(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_1(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_1(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_1(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_7});
    IDClass_1 = $;
  }
  return IDClass_1;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_8() {
  return Companion_instance_6;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.FcmToken', this, 6);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (MaxLength())(160, 142));
        tmp0_serialDesc.addElement_5pzumi_k$('user', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.addElement_5pzumi_k$('created', true);
        tmp0_serialDesc.addElement_5pzumi_k$('lastRegisteredAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('userAgent', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['userAgent', 'lastRegisteredAt']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['user', 'active', 'userAgent', 'lastRegisteredAt']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-lastRegisteredAt']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_u0pjg2_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_7(), new (ID_1())(value._id_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_5(), new (ID_0())(value.user_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.active_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 2, value.active_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !value.created_1.equals(now())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, InstantSerializer_getInstance(), value.created_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !value.lastRegisteredAt_1.equals(value.created_1)) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, InstantSerializer_getInstance(), value.lastRegisteredAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.userAgent_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, StringSerializer_getInstance(), value.userAgent_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_u0pjg2_k$(encoder, value instanceof FcmToken() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_7();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_1())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_5();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_0())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_7();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (ID_1())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_8 = $serializer_getInstance_5();
                var tmp_9 = tmp5_local1;
                var tmp_10 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_8, tmp_9 == null ? null : new (ID_0())(tmp_9));
                tmp5_local1 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FcmToken().new_org_thecommunitygroupinc_cares_FcmToken_u9xtjh_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_7(), $serializer_getInstance_5(), BooleanSerializer_getInstance(), InstantSerializer_getInstance(), InstantSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_8() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var FcmTokenClass;
function FcmToken() {
  if (FcmTokenClass === VOID) {
    class $ {
      constructor(_id, user, active, created, lastRegisteredAt, userAgent) {
        active = active === VOID ? true : active;
        created = created === VOID ? now() : created;
        lastRegisteredAt = lastRegisteredAt === VOID ? created : lastRegisteredAt;
        userAgent = userAgent === VOID ? null : userAgent;
        this._id_1 = _id;
        this.user_1 = user;
        this.active_1 = active;
        this.created_1 = created;
        this.lastRegisteredAt_1 = lastRegisteredAt;
        this.userAgent_1 = userAgent;
      }
      get__id_bq27l5_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_1())(this.get__id_bq27l5_k$());
      }
      toString() {
        return 'FcmToken(_id=' + ID__toString_impl_y5caka_1(this._id_1) + ', user=' + ID__toString_impl_y5caka_0(this.user_1) + ', active=' + this.active_1 + ', created=' + this.created_1.toString() + ', lastRegisteredAt=' + this.lastRegisteredAt_1.toString() + ', userAgent=' + this.userAgent_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_1(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_0(this.user_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        result = imul(result, 31) + this.created_1.hashCode() | 0;
        result = imul(result, 31) + this.lastRegisteredAt_1.hashCode() | 0;
        result = imul(result, 31) + (this.userAgent_1 == null ? 0 : getStringHashCode(this.userAgent_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FcmToken()))
          return false;
        if (!(this._id_1 === other._id_1))
          return false;
        if (!equals(this.user_1, other.user_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        if (!this.created_1.equals(other.created_1))
          return false;
        if (!this.lastRegisteredAt_1.equals(other.lastRegisteredAt_1))
          return false;
        if (!(this.userAgent_1 == other.userAgent_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_FcmToken_u9xtjh_k$(seen0, _id, user, active, created, lastRegisteredAt, userAgent, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_8().descriptor_1);
        }
        var $this = createThis(this);
        $this._id_1 = _id;
        $this.user_1 = user;
        if (0 === (seen0 & 4))
          $this.active_1 = true;
        else
          $this.active_1 = active;
        if (0 === (seen0 & 8))
          $this.created_1 = now();
        else
          $this.created_1 = created;
        if (0 === (seen0 & 16))
          $this.lastRegisteredAt_1 = $this.created_1;
        else
          $this.lastRegisteredAt_1 = lastRegisteredAt;
        if (0 === (seen0 & 32))
          $this.userAgent_1 = null;
        else
          $this.userAgent_1 = userAgent;
        return $this;
      }
    }
    initMetadataForClass($, 'FcmToken', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_8});
    FcmTokenClass = $;
  }
  return FcmTokenClass;
}
function UserRole_Anonymous_getInstance() {
  static_init();
  return UserRole_Anonymous_instance;
}
function UserRole_User_getInstance() {
  static_init();
  return UserRole_User_instance;
}
function UserRole_Admin_getInstance() {
  static_init();
  return UserRole_Admin_instance;
}
function UserRole_Developer_getInstance() {
  static_init();
  return UserRole_Developer_instance;
}
function UserRole_Root_getInstance() {
  static_init();
  return UserRole_Root_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_2 = new (Companion_1())();
Companion_instance_5 = new (Companion_4())();
Companion_instance_6 = new (Companion_5())();
//endregion
//region block: exports
export {
  _ID___init__impl__k1lb7e_1 as _ID___init__impl__k1lb7e2iy8126dkzvej,
  _ID___init__impl__k1lb7e_0 as _ID___init__impl__k1lb7e3nwubwpb014i6,
  ID__hashCode_impl_f4lulz_0 as ID__hashCode_impl_f4lulz34r5frdiblcos,
  ID__toString_impl_y5caka_0 as ID__toString_impl_y5cakadb8fzjf8iy39,
  UserRole_Admin_getInstance as UserRole_Admin_getInstance1ewshxr51h257,
  UserRole_Developer_getInstance as UserRole_Developer_getInstance37yg34uou1phs,
  UserRole_Root_getInstance as UserRole_Root_getInstance2onjxwzt8221j,
  UserRole_User_getInstance as UserRole_User_getInstance3eetxpzgtepd2,
  Companion_getInstance_3 as Companion_getInstance1ljiqntaxe0m9,
  Companion_instance_0 as Companion_instancexzjj08lu6v7y,
  Companion_instance_6 as Companion_instancen4rpxo41w4o4,
  Companion_instance_5 as Companion_instance2wd0q10x4wldy,
  Companion_getInstance_5 as Companion_getInstance2r6pafkc2qafn,
  $serializer_getInstance_5 as $serializer_getInstances2uba6hlovkk,
  Companion_instance_2 as Companion_instancef6fjaxfv49x1,
  Companion_getInstance_6 as Companion_getInstance1jgvg3kcoy2nr,
  AppRelease as AppReleasenhe0u1o4ickq,
  ID_1 as ID1eab8795lyj01,
  FcmToken as FcmTokenzn8ju01ll1ql,
  ID_0 as ID2ebczrc12h07k,
  get_entries as get_entries208xk6b864p6f,
  User as User3mqs8plvl8nwo,
};
//endregion

//# sourceMappingURL=models.mjs.map
